import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../_metronic/helpers'
import { getHistoricoNotasVersao } from './_requests'
import { NotaVersaoUsuarioItem } from './_models'
import { useHistoricoQueryRequest } from './HistoricoQueryRequestProvider'

const HistoricoQueryResponseContext =
  createResponseContext<NotaVersaoUsuarioItem>(initialQueryResponse)

export const HistoricoQueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { state } = useHistoricoQueryRequest()
  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery(
    [QUERIES.NOTAS_VERSAO_HISTORICO, 'lista', query],
    () => getHistoricoNotasVersao(query),
    { keepPreviousData: true, refetchOnWindowFocus: false }
  )

  return (
    <HistoricoQueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </HistoricoQueryResponseContext.Provider>
  )
}

export const useHistoricoQueryResponse = () => useContext(HistoricoQueryResponseContext)
